import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["dragGroup", "items", "onOrderChange"];
//@ts-expect-error no types
import UISortableList from 'ui-addon-draggable/list/UISortableList';
//@ts-expect-error no types
import UIDragListItem from 'ui-addon-draggable/list/UIDragListItem';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SortableList(_ref) {
  let {
      dragGroup,
      items,
      onOrderChange
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleOrderChange = useCallback(ids => {
    if (onOrderChange) {
      const itemsById = new Map(items.map(item => [item.id, item]));
      const newItemsOrder = ids.map(id => itemsById.get(id)).filter(x => x !== undefined);
      onOrderChange(newItemsOrder);
    }
  }, [items, onOrderChange]);
  return /*#__PURE__*/_jsx(UISortableList, Object.assign({
    onOrderChange: handleOrderChange,
    dragGroup: dragGroup || 'DEFAULT_GROUP',
    order: items.map(item => item.id)
  }, rest, {
    children: items.map(item => /*#__PURE__*/_jsx(UIDragListItem, {
      dragId: item.id,
      children: item.children
    }, item.id))
  }));
}